<template>
  <div class="recommend-swiper">
    <div class="relative block md:flex md:items-start">
      <div class="special-title text-xl font-medium mb-24 md:mb-0">{{ block.title }}</div>
      <swiper :options="optionsRecommend" :ref="`section-recommend-hotel-${cid}`">
        <swiper-slide v-for="(hotel, index) in block.items" :key="`swiper-section-recommend-hotel-${index}`">
          <router-link class="no-underline" :to="goToHotel(hotel)" target="_blank">
            <div>
              <div class="recommend-swiper__cover img" v-lazy:background-image="hotel.coverImage || require('@/assets/images/default-room.jpg')" style="border-radius: 16px;" />
              <div class="text-xl font-medium mt-16 text-grey-darkest">{{ event.entities.hotels[hotel.hotelUUID].hotelNameLocal }}</div>
              <div class="flex justify-between mt-8 items-center">
                <p class="text-grey-darker text-sm">{{ event.entities.hotels[hotel.hotelUUID].placesText }} | {{ event.entities.hotels[hotel.hotelUUID].hotelType.name }}</p>
                <p v-if="hotel.price" class="text-base font-bold text-grey-darkest">{{ currencySign }} {{ Number(hotel.price) | currencyConvert({inputCurrency: hotel.currency, listInteger: true}) }}～</p>
              </div>
              <p class="special-desp my-16 desp text-base whitespace-pre-wrap text-grey-darkest" style="line-height: 1.75;" v-html="hotel.intro"></p>
            </div>
          </router-link>
        </swiper-slide>
      </swiper>
    </div>
    <div class="relative hidden md:flex items-center justify-end mt-8" v-show="swiperButtonShow">
      <div class="hidden md:flex items-center justify-center" style="width: fit-content; gap: 8px; margin-right: 60px">
        <div class="flex items-center justify-center" :class="`swiper-button-prev swiper-button-prev-${cid}`" slot="button-prev">
          <i class="owl-direction-left"></i>
        </div>
        <div class="flex items-center justify-center" :class="`swiper-button-next swiper-button-next-${cid}`" slot="button-next">
          <i class="owl-direction-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RecommendSwiper',
  props: {
    block: {
      type: Object,
      default: () => {}
    },
    event: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      cid: this._uid,
      optionsRecommend: {
        loop: false,
        preventInteractionOnTransition: true,
        slideToClickedSlide: false,
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
        },
        breakpoints: {
          3000: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 16
          },
          2000: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 16
          },
          1300: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 1.5,
            slidesPerGroup: 1.5,
            spaceBetween: 16
          },
          430: {
            slidesPerView: 1.1,
            slidesPerGroup: 1.1,
            spaceBetween: 16
          }
        }
      },
      swiperButtonShow: false
    }
  },
  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      selectedLang: 'user/selectedLang',
      currencySign: 'user/currencySign',
      currency: 'user/selectedCurrency',
      initWidth: 'initWidth'
    })
    // swiperButtonShow() {
    // if ((this.initWidth >= 768 && this.initWidth <= 1024) && this.block.items.length > 1) {
    //   return true
    // } else if ((this.initWidth > 1024 && this.initWidth <= 1300) && this.block.items.length > 2) {
    //   return true
    // } else if (this.initWidth > 1300 && this.block.items.length > 3) {
    //   return true
    // }
    // return false
    // }
  },
  methods: {
    goToHotel: function (hotel) {
      return {
        name: 'HotelDetail',
        params: { hotelId: hotel.hotelUUID },
        query: {
          externalId: hotel.hotelUUID,
          searchId: hotel.hotelUUID,
          searchType: 'hotel',
          source: this.event.entities.hotels[hotel.hotelUUID].source
        }
      }
    }
  },
  mounted () {
    // console.log('swiper container width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.width)
    // console.log('all slides width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.virtualSize)
    this.$nextTick(() => {
      const swiperWidth = this.$refs[`section-recommend-hotel-${this.cid}`]?.swiper?.width
      const swiperSlideWidth = this.$refs[`section-recommend-hotel-${this.cid}`]?.swiper?.virtualSize
      if (swiperSlideWidth > swiperWidth) {
        this.swiperButtonShow = true
      } else {
        this.swiperButtonShow = false
      }
    })
  }
}
</script>
<style lang="sass" scoped>
@import '@/assets/style/_mixins.sass'
.recommend-swiper
  .swiper-container
    @apply mx-0 w-full
    // overflow: visible
    .swiper-slide
      min-width: 320px
      @screen md
        max-width: 500px
  .special-title
    @apply w-full
    @screen md
      min-width: 224px
      max-width: 224px
  .special-desp
    @include ellipsis(3)
  &__cover
    @apply bg-cover bg-center relative
    transition-duration: .5s
    padding-top: imageRatio(500, 300)
    // &:hover
    //   transform: scale(1.05)
  .recommend-child:not(:last-child)
    margin-bottom: 60px
    @screen md
      margin-bottom: 100px
</style>
<style lang="sass">
.recommend-swiper
  .swiper-button-prev, .swiper-button-next
    @apply outline-none #{!important} rounded-full bg-grey-lightest
    position: relative !important
    background-image: none !important
    width: 35px !important
    height: 35px !important
    margin-top: 0px !important
    z-index: 8
    i[class*=owl-direction]
      @apply text-grey-darkest
      font-size: 18px
  .swiper-button-prev
    left: initial
    // @screen sm
    //   left: -5px !important
  .swiper-button-next
    right: initial
    // @screen sm
    //   right: -5px !important
  .swiper-button-disabled
    @apply cursor-not-allowed
</style>
